import { createContext } from "react";
import type { LayoutSettings, LayoutFeatures } from "../types";

export interface VGroveContextType {
    settings: LayoutSettings;
    updateSettings: (newSettings: Partial<LayoutSettings>) => void;
    resetSettings: () => void;
    features: LayoutFeatures;
    // 🎯 新增：布局加载状态管理
    /** 布局是否正在加载中 */
    isLayoutLoading: boolean;
    /** 布局是否已完成加载 */
    isLayoutReady: boolean;
    /** 设置布局完成状态 */
    setLayoutReady: (ready: boolean) => void;
    /** 重置布局状态（用于路由切换） */
    resetLayoutState: () => void;
}

export const VGroveContext = createContext<VGroveContextType | undefined>(undefined); 